export default "__VITE_ASSET__c9f0d22d__"